var exports = {
  "K": "x234b8571--7470da--seo-li",
  "A": "x234b8571--7470da--seo-ul",
};

module.exports = exports;
